import { ApiErrorTypes, InterviewOrigin, InterviewStatus } from '../../types';
import { AppContext } from '../../context';
import { Link, Redirect, useLocation, useParams } from 'react-router-dom';
import { stopAvailabilitySearch } from '../../api';
import CompanyDetails from './components/CompanyDetails';
import ListInterviews from './components/ListInterviews';
import React, { useContext, useEffect } from 'react';
import Wrapper from '../../components/Wrapper';

import './styles.scss';

const Intro: React.FC = () => {
    const { meetIntro, bootstrapApp, translate, storeAndSendUserAction } = useContext(AppContext);
    const { showInterviewSummaryToGuest = false } = meetIntro?.data || {};
    const { hash } = useParams<{ hash: string }>();
    const { search } = useLocation();

    const primaryColor = meetIntro?.data?.meetCompanyColor ? meetIntro?.data?.meetCompanyColor : '#6400E0';
    const backgroundImage = meetIntro?.data?.meetBackgroundUrlList[0];
    const logo = meetIntro?.data?.organization?.logoUrl;

    let textColor = '#FFFFFF';
    if (meetIntro?.data?.meetFontColor) {
        textColor = meetIntro?.data?.meetFontColor;
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        if (!meetIntro) {
            bootstrapApp(hash, searchParams.get('source'));
        }
    }, [hash, bootstrapApp, search, meetIntro]);

    useEffect(() => {
        if (primaryColor) {
            document.documentElement.style.setProperty('--primary-date-picker-color', primaryColor);
        }
        if (textColor) {
            document.documentElement.style.setProperty('--primary-text-color', textColor);
        }
    }, [primaryColor, textColor]);

    if (meetIntro?.data?.interview?.origin === InterviewOrigin.SUPERDAY) {
        document.location.href = `/s/intro/${hash}`;
        return null;
    }

    if (meetIntro && !meetIntro.isLoading) {
        if (meetIntro?.error === ApiErrorTypes.REQUEST_AVAILABILITY_TIME_WINDOW_EXPIRED) {
            stopAvailabilitySearch('expired');
            return <Redirect to={`/expired/${hash}`} />;
        }
        if (meetIntro?.error === ApiErrorTypes.CANCELED_INTERVIEW) {
            stopAvailabilitySearch('cancelled');
            return <Redirect to={'/invalid-link'} />;
        }
        if (meetIntro?.data?.interview.status === InterviewStatus.RESCHEDULE) {
            return <Redirect to={`/pickDays/${hash}`} />;
        }

        if (
            meetIntro?.data?.interview.status !== InterviewStatus.PENDING_REVIEW &&
            meetIntro?.data?.interview.status !== InterviewStatus.PENDING_CANDIDATE_RESPONSE
        ) {
            stopAvailabilitySearch('confirmed');
            return <Redirect to={`/confirm/${hash}`} />;
        }
    }
    const handleDataDogEvent = () => {
        storeAndSendUserAction(hash, 'clickIntroButton');
    };

    return (
        <Wrapper loading={meetIntro?.isLoading} backgroundImage={backgroundImage} logo={logo}>
            <div className="flexCard">
                <div className={`flexCardBodyLeft ${showInterviewSummaryToGuest ? '' : 'full-width-body'}`}>
                    <CompanyDetails
                        candidate={meetIntro?.data?.guest}
                        recruiter={meetIntro?.data?.emailSender}
                        organization={meetIntro?.data?.organization}
                        meetAboutCompany={meetIntro?.data?.meetAboutCompany}
                        meetIntroHeader={meetIntro?.data?.meetIntroHeader}
                        meetIntroSubheader={meetIntro?.data?.meetIntroSubheader}
                    />
                </div>
                {showInterviewSummaryToGuest && (
                    <div className="flexCardBodyRight">
                        <ListInterviews
                            events={meetIntro?.data?.interview?.events}
                            greetEvent={meetIntro?.data?.interview?.greetEvent}
                            walkoutEvent={meetIntro?.data?.interview.walkoutEvent}
                        />
                    </div>
                )}
                <div className="flexCardFooter">
                    <Link to={`/pickDays/${hash}`} onClick={handleDataDogEvent} className="flexCardFooterButton">
                        <span>{translate('intro:getStarted')}</span>
                    </Link>
                </div>
            </div>
        </Wrapper>
    );
};

export default Intro;
